import React from 'react';
import MessageHeader, { MessageMeta } from './MessageHeader';
import ReplyForm from './ReplyForm';

const MessageDetailModal = ({
  message,
  formatDate,
  staffProfiles,
  selectedSender,
  setSelectedSender,
  replyMessage,
  setReplyMessage,
  replyLoading,
  replyStatus,
  onClose,
  onSendReply,
  onToggleStatus,
  onDelete,
}) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="message-modal" onClick={(e) => e.stopPropagation()}>
      <MessageHeader message={message} onClose={onClose} />
      <MessageMeta message={message} formatDate={formatDate} />

      <div className="message-modal-subject">
        <strong>Subject:</strong> {message.subject}
      </div>

      <div className="message-modal-content">
        <div className="original-message-label">Original Message:</div>
        {message.message}
      </div>

      <ReplyForm
        message={message}
        staffProfiles={staffProfiles}
        selectedSender={selectedSender}
        setSelectedSender={setSelectedSender}
        replyMessage={replyMessage}
        setReplyMessage={setReplyMessage}
        replyLoading={replyLoading}
        replyStatus={replyStatus}
        onSendReply={onSendReply}
        onToggleStatus={onToggleStatus}
        onDelete={onDelete}
      />
    </div>
  </div>
);

export default MessageDetailModal;
